import { type ChangeEvent, type FormEvent, type KeyboardEvent, useState } from 'react';

type Props = {
  onSubmit: (text: string) => void;
  disabled?: boolean;
};

export function useChatComposer(props: Props) {
  const [draft, setDraft] = useState('');

  const canSubmit = !props.disabled && draft.trim().length > 0;

  function submit() {
    if (!canSubmit) {
      return;
    }
    props.onSubmit(draft.trim());
    setDraft('');
  }

  function handleChange(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setDraft(event.target.value);
  }

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    submit();
  }

  /** Enter sends, Shift+Enter adds a line break. */
  function handleKeyDown(event: KeyboardEvent<HTMLDivElement>) {
    if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
      event.preventDefault();
      submit();
    }
  }

  return {
    draft,
    canSubmit,
    handleChange,
    handleSubmit,
    handleKeyDown,
  };
}
